


















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BoxCompare from '@/BoxCompare.vue';
import CentralView from '@/CentralView.vue';
import AppMenu from '@/AppMenu.vue'
import { Project } from '../../../common/project';
import { Box } from '../../../common/box';
import { apolloClient } from '../apollo';
import store from '../store';

import * as PROJECT_QUERY from 'src/graphql/Project.graphql';
import * as BOX_QUERY from 'src/graphql/Box.graphql';
import * as FEATURES_QUERY from 'src/graphql/Features.graphql';

@Component({
  components: {
    BoxCompare,
    CentralView,
    AppMenu
  },
  apollo: {
    project_with_path: {
      query: PROJECT_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return {
          path: this.path,
        }
      },
      result({ data, loading, networkStatus }) {
        if (!loading && data.project_with_path === null) {
          store.commit('setError', {
            msg: 'The project could not be found. Please go back to the project list by clicking the SCA logo.',
            permissionError: true,
          });
        }
      },
    },
    box_with_path: {
      query: BOX_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return {
          path: this.path,
        }
      },
    },
    features_for_group: {
      query: FEATURES_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class extends Vue {
  project_with_path: any = null;
  box_with_path: any = null;
  features_for_group: any = [];
  // project: Project = null;
  showProjectLockLost = false;
  showStealLockDialog = false;
  didStealLock = false;

  @Watch('projectLockOwner')
  onEditLockChange(owner, old) {
    const uid = this.$store.state.auth.idTokenDecoded.sub;
    const hadLock = old && old.user_id === uid;

    // Check if lock was lost
    if (hadLock && owner && owner.user_id !== uid) {
      this.showProjectLockLost = true;
    }

    if (owner && owner.user_id !== uid) {
      // If someone else is editing, start (or continue) polling for changes.
      this.startPolling();
    }

    if (!owner || owner.user_id === uid) {
      // If we or no one else is editing, stop polling for changes.
      this.stopPolling();
    }

    // Check if lock was acquired
    // Refetch to get changes from previous editor
    // Skip if we just entered the project, in which case it was just loaded
    const otherHadLock = old && old.user_id !== uid;
    const hasLock = owner && owner.user_id === uid;
    if (otherHadLock && hasLock && !this.didStealLock) {
      console.log(`refetch!`);

      this.project_with_path = null;
      this.$store.commit('setCurrentProject', new Project());
      this.$apollo.queries.project_with_path.refetch();
      this.$apollo.queries.box_with_path.refetch();
    }

    this.didStealLock = false;
  }

  get project() {
    const p = this.$store.state.currentProject;
    return p && p.id !== undefined ? p : null;
  }

  get projectLockOwner() {
    return this.$store.state.projectLockOwner;
  }


  restoreProject(eProject: any) {
    const project = Project.restore(eProject);
    let outdated = false;

    for (let i = 0; i < project.boards.length; i++) {
      const board = project.boards[i];

      if (board.board_result != null) {
        const simulationResults: any = {};
        Object.assign(simulationResults, board.board_result);

        for (const result of project.simulation_results) {
          if (result.board_snapshot.board.id == board.id) {
            Object.assign(simulationResults, result);
          }
        }

        board.setSimulationResult(simulationResults, project);

        if (simulationResults.outdated_simulation_parameters && board.hasSimulationSuccess() && board.visible) {
          outdated = true;
        }
      }

      board.cssClass      = 'boardColor' + (i%7 + 1);
      board.cssClassDark  = 'boardColor' + (i%7 + 1) + 'Dark';
      board.cssClassLight = 'boardColor' + (i%7 + 1) + 'Light';
      board.index = i;
    }

    this.$store.state.outdatedSimulationParameters = outdated;

    return project;
  }

  @Watch('project_with_path')
  onProjectChanged(val: any, oldVal: any) {

    if (!val) {
      return;
    }

    let project = this.restoreProject(this.project_with_path);

    if (this.box_with_path) {
      project.box = Box.restore(this.box_with_path);
    }

    const hasProject = !!this.project;

    this.$store.commit('setProjectLockOwner', this.project_with_path.editLockOwner);
    this.$store.commit('setCurrentProject', project);

    // Check if first fetch
    if (!hasProject) {
      // Check if we can take the lock
      const lockOwner = this.$store.state.projectLockOwner;
      if (!this.$store.getters.hasProjectLock) {
        if (!lockOwner) {
          this.$store.commit('acquireProjectLock');
        } else {
          this.showStealLockDialog = true;
          this.didStealLock = false;
        }
      }
    }

  }

  get lockStealDescription() {
    const lockOwner = this.$store.state.projectLockOwner;
    return `Only one user may edit the project at any time. The editing lock is currently held by ${lockOwner && lockOwner.name}. Either take the lock, or open the project in view only mode.`;
  }

  overtakeLock() {
    this.showStealLockDialog = false;
    this.didStealLock = true;
    this.$store.commit('acquireProjectLock');
  }

  startPolling() {
    this.$apollo.queries.project_with_path.startPolling(5000);
    this.$apollo.queries.box_with_path.startPolling(5000);
  }

  stopPolling() {
    this.$apollo.queries.project_with_path.stopPolling();
    this.$apollo.queries.box_with_path.stopPolling();
  }

  @Watch('box_with_path')
  onBoxChanged() {
    if (this.project) {
      this.project.box = Box.restore(this.box_with_path);
      this.$store.commit('setCurrentProject', this.project);
    }
  }

  @Watch('features_for_group')
  onFeaturesChanged() {
    this.$store.commit('setFeatures', this.features_for_group);
  }

  beforeDestroy() {
    // Unlock current project
    this.$store.commit('releaseProjectLock');
    this.$store.commit('setCurrentProject', new Project());
    this.stopPolling();
  }

  get pathComponents() {
    return [
      {
        text: (this.project != null ? this.project.owner : '...'),
        disabled: true
      },
      {
        text: 'Project: ' + (this.project != null ? this.project.name : 'Loading...'),
        disabled: true
      }
    ];
  }

  get path() {
    // console.log(`get path! ${this.$route.params.project}`);

    const { group, project } = this.$route.params;
    return `${group}/${project}`;
  }

  get anyActiveSimulation() {
    return this.$store.getters.anyActiveSimulation;
  }

  @Watch('anyActiveSimulation')
  onAnyActiveSimulation() {
    if (!this.anyActiveSimulation)
      this.$apollo.queries.project_with_path.refetch();
  }

  async mounted() {
    console.log(`Project ${this.path} mounted`);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Project.vue